import {apiSlice} from './apiSlice';

// Define a service using a base URL and expected endpoints
export const migrationApi = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    createMigration: builder.mutation({
      query: body => ({
        url: 'migration/',
        method: 'POST',
        body: {},
      }),
      invalidatesTags: [],
    }),
  }),
});

// Export hooks for usage in functional components, which are
// auto-generated based on the defined endpoints
export const {
  useCreateMigrationMutation
} = migrationApi;
